import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  meetContainer: css`
    width: 100%;
    height: 100%;
  `,

  fullScreenMeet: css`
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;

    #roomContainer {
      height: 100%;

      @media (min-width: 500px) {
        height: 100%;
      }
    }
  `,
})

export { useStyles }
